export default __webpack_public_path__ + "static/media/header-visu4.9c164480.jpg";